/** Display labels for desk roles. Custom Admin-created roles fall back to Title Case. */
const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  dm: 'District Magistrate',
  peshkar: 'Peshkar',
  officer: 'Department Officer',
  records_officer: 'Records Officer',
  citizen: 'Citizen',
};

export function roleLabel(role: string | null | undefined, fallback = 'Officer'): string {
  if (!role) return fallback;
  return (
    ROLE_LABELS[role]
    || role
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')
  );
}
